export const UPDATE_CART = "UPDATE_CART";
export const CLEAR_CART = 'CLEAR_CART';
export const SET_CART_EXPIRATION = 'SET_CART_EXPIRATION';
export const CLEAR_STORE_ITEM = 'CLEAR_STORE_ITEM';